import React, { useEffect } from 'react';
import bem from '../../../../lib/bemUtils/bem';
import { Tooltip, TooltipPlacement } from '../../../atoms/Tooltip';
import { appendClassNames } from '../../../../lib/bemUtils/classname';
import { BtnModifier } from '..';
import { Modifier } from '../../../../lib/bemUtils/Modifier';
import { LinkProps } from '../../../../types/HtmlProps';
import { useRefProp } from './useRefProp';

type AnchorProps = LinkProps & {
  modifier?: Modifier<BtnModifier>;
  tooltipPlacement?: TooltipPlacement;
  hideTooltipFromScreenReader?: true;
  focusOnMount?: true;
  children: React.ReactElement;
  ref?: React.RefObject<HTMLAnchorElement | null>;
};

export function Anchor({
  className,
  hideTooltipFromScreenReader,
  tooltipPlacement,
  children,
  modifier,
  focusOnMount,
  onClick,
  onKeyDown,
  onKeyUp,
  ref,
  ...props
}: AnchorProps) {
  const { innerRef, refCallback } = useRefProp(ref);

  useEffect(() => {
    if (focusOnMount && innerRef.current) {
      innerRef.current.focus();
    }
  }, [focusOnMount, innerRef]);

  return (
    <Tooltip attachTo={innerRef} placement={tooltipPlacement} hideTooltipFromScreenReader={hideTooltipFromScreenReader}>
      <a
        ref={refCallback}
        className={appendClassNames(className, bem('btn', modifier))}
        role={props.role}
        onClick={!props['aria-disabled'] ? onClick : undefined}
        onKeyDown={!props['aria-disabled'] ? onKeyDown : undefined}
        onKeyUp={!props['aria-disabled'] ? onKeyUp : undefined}
        {...props}
      >
        {children}
      </a>
    </Tooltip>
  );
}
